define(function () {
    'use strict';

    return function ($rootScope, ApiService) {
       return {
            User: $rootScope.globals.currentUser.username,
            HasRole: function(role){
            }
       }
    }
});


/** WEBPACK FOOTER **
 ** ./js/services/user.js
 **/